export function isSitecoreEditorMode() {
  return (
    typeof window !== "undefined" &&
    typeof window.Sitecore !== "undefined" &&
    window.Sitecore &&
    window.Sitecore.PageModes &&
    window.Sitecore.PageModes.PageEditor
  );
}
